module.exports = __webpack_public_path__ + "img/ic_cg_hover.2e5cae89.svg";